module.exports = __webpack_public_path__ + "static/media/info_btn.ce9a02dc.svg";